import { createFeatureSelector } from 'common/create-feature-selector';
import { createSelector } from 'reselect';

const rootSelector = createFeatureSelector('brandsFilter');

export const getBrandsFilter = createSelector(rootSelector, (f) => f);
